export default __webpack_public_path__ + "static/media/cushion-reversed.cdc4cb1b.svg";